var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroduction1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 57,
    viewBox: "0 0 68 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.8742 48.043H0.526367V0.855835H67.3765V48.043H34.6253",
    stroke: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54.438 1.92841V6.21814M1.6048 7.29058H66.2985H1.6048ZM63.0637 1.92841V6.21814V1.92841ZM58.7509 1.92841V6.21814V1.92841Z",
    stroke: "#F5FBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.2322 43.7534H4.83926V11.5803H63.0635V43.7534H37.1403",
    stroke: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.0911 25.522V42.681M5.91772 35.1739H11.2751L22.0743 24.4495L30.717 30.9491V42.681L5.91772 35.1739ZM60.2992 24.4495H61.9856H60.2992ZM11.3088 36.2463V42.681V36.2463Z",
    stroke: "#F5FBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.6554 21.2321V35.9878",
    stroke: "#F5FBFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M54.4381 38.4579V42.681",
    stroke: "#F5FBFF",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.8983 35.0268C12.8983 35.9327 12.1592 36.6717 11.2418 36.6717C10.3244 36.6717 9.58536 35.9328 9.58536 35.0268C9.58536 34.1209 10.3244 33.382 11.2418 33.382C12.1592 33.382 12.8983 34.1209 12.8983 35.0268Z",
    fill: "#F5FBFF",
    stroke: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.6185 26.2172L43.5547 21.4332L53.8317 25.6559",
    stroke: "#F5FBFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M47.8842 23.5539C47.8842 25.8979 45.9731 27.8027 43.6099 27.8027C41.2466 27.8027 39.3355 25.8979 39.3355 23.5539C39.3355 21.21 41.2466 19.3052 43.6099 19.3052C45.9731 19.3052 47.8842 21.21 47.8842 23.5539Z",
    fill: "#F5FBFF",
    stroke: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M23.7303 24.633C23.7303 25.5389 22.9912 26.2778 22.0739 26.2778C21.1565 26.2778 20.4174 25.5389 20.4174 24.633C20.4174 23.727 21.1565 22.9881 22.0739 22.9881C22.9912 22.9881 23.7303 23.727 23.7303 24.633Z",
    fill: "#F5FBFF",
    stroke: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M35.1503 38.7779L26.6946 53.3448C26.0973 54.3739 26.4492 55.6811 27.4838 56.2751C28.5185 56.8693 29.8323 56.5188 30.4297 55.4897L38.8855 40.9228L35.1503 38.7779ZM45.6382 11.5777C48.0711 11.6399 50.5256 12.293 52.7814 13.5886C60.0002 17.7339 62.4751 26.9189 58.3073 34.0988C54.1397 41.2788 44.905 43.7404 37.6863 39.595C30.4675 35.4497 27.9926 26.2647 32.1603 19.0848C35.0256 14.1485 40.2859 11.4393 45.6382 11.5777ZM46.4469 17.0069C42.6946 16.5436 38.8196 18.3041 36.8102 21.7658C34.131 26.3816 35.7413 32.3051 40.3818 34.9702C45.0224 37.635 50.9782 36.0335 53.6574 31.4177C56.3368 26.802 54.7265 20.9452 50.0859 18.2804C48.9257 17.6142 47.6976 17.1611 46.4469 17.0069Z",
    fill: "#FEA219"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduction1);
export default __webpack_public_path__ + "static/media/introduction-1.d7c67a65.svg";
export { ForwardRef as ReactComponent };